import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';
import logo from '../assets/logo.jpeg';

// Use relative URL in production for same-origin requests
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:8000');

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/blog/public/`);
        if (response.ok) {
          const data = await response.json();
          setBlogPosts(data);
        }
      } catch (err) {
        console.error('Failed to fetch blog posts:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
  };

  return (
    <div className="blog-page">
      {/* Navigation */}
      <nav className="landing-nav">
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            <img src={logo} alt="KrossIQ" className="logo-image" />
          </Link>
          <div className="nav-links">
            <Link to="/#features">Features</Link>
            <Link to="/#how-it-works">How It Works</Link>
            <Link to="/#download">Download</Link>
            <Link to="/#pricing">Pricing</Link>
            <Link to="/blog" className="active">Blog</Link>
          </div>
          <div className="nav-actions">
            <Link to="/#contact" className="btn btn-outline btn-sm">Book Demo</Link>
            <Link to="/#download" className="btn btn-primary btn-sm">Download</Link>
          </div>
        </div>
      </nav>

      {/* Blog Header */}
      <section className="blog-header">
        <div className="section-container">
          <h1>KrossIQ Blog</h1>
          <p>Insights, tutorials, and best practices for market research data analysis</p>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="blog-list">
        <div className="section-container">
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="blog-grid">
              {blogPosts.map((post) => (
                <Link to={`/blog/${post.slug}`} key={post.id || post.slug} className="blog-card">
                  <div className="blog-card-image">
                    {post.featured_image ? (
                      <img src={post.featured_image} alt={post.title} />
                    ) : (
                      <div className="blog-card-placeholder">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" y1="13" x2="8" y2="13" />
                          <line x1="16" y1="17" x2="8" y2="17" />
                        </svg>
                      </div>
                    )}
                  </div>
                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="blog-category">{post.category}</span>
                      <span className="blog-date">{formatDate(post.created_at)}</span>
                    </div>
                    <h2>{post.title}</h2>
                    <p>{post.excerpt}</p>
                    <div className="blog-card-footer">
                      <span className="read-time">{post.read_time}</span>
                      <span className="read-more">Read more &rarr;</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="blog-footer">
        <div className="footer-container">
          <div className="footer-brand">
            <Link to="/" className="nav-logo">
              <img src={logo} alt="KrossIQ" className="logo-image" />
            </Link>
            <p>Powerful data tabulation & analysis for market research professionals.</p>
          </div>
          <div className="footer-links-simple">
            <Link to="/">Home</Link>
            <Link to="/#features">Features</Link>
            <Link to="/#pricing">Pricing</Link>
            <Link to="/#download">Download</Link>
            <a href="mailto:support@krossiq.com">Contact</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} KrossIQ. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Blog;
